module.exports = __webpack_public_path__ + "static/media/registerActive.e9125a30.svg";